<ng-container [ngSwitch]="inputType">
  <button class="btn mapfre btn-loading {{ additionalClasses }}" [ngClass]="{ 'loading-btn-state': loading }"
    [disabled]="!isFormValid()" *ngSwitchCase="'loading-button'" mdbRipple>
    <ng-contaitner *ngIf="loading">
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </ng-contaitner>
    <ng-contaitner *ngIf="!loading">
      {{ buttonCopy | translate }}
    </ng-contaitner>
  </button>

  <button class="btn mapfre {{ additionalClasses }}" [disabled]="!isFormValid()" *ngSwitchCase="'button-form'"
    mdbRipple>
    <ng-container *ngIf="showIcons">
      <span>
        <mapfre-icon [iconClasses]="iconClasses" [iconFamily]="iconFamily"></mapfre-icon>
      </span>
    </ng-container>
    <ng-content></ng-content>
  </button>

  <button type="submit" class="btn mapfre {{ additionalClasses }}" [disabled]="!isFormValid()"
    [ngStyle]="{ 'cursor: not-allowed;': !isFormValid() }" *ngSwitchCase="'submit'" mdbRipple>
    {{ translateValue }}
  </button>

  <button class="btn mapfre {{ additionalClasses }}" [disabled]="!isFormValid()" data-toggle="modal" type="button" *ngSwitchCase="'modal'"
    [ngClass]="{
      'btn-icon': screenReader,
      default: !moreCSSClasses(additionalClasses)
    }" mdbRipple>
    <ng-container *ngIf="
        additionalClasses.includes('header-flat') &&
        !additionalClasses.includes('account')
      ">
      <mapfre-icon [iconClasses]="iconClassesArray[0]" [iconFamily]="iconFamily" [header]="true"></mapfre-icon>
    </ng-container>

    <ng-container *ngIf="
        additionalClasses.includes('header-flat') &&
        additionalClasses.includes('account')
      ">
      <ng-container *ngIf="stateCode !== 'MA'; else otherState">
        <div class="header-profile-icon-for-mobile">
          <div class="header-icon-icon-height hide-safari">
            <img src="assets/SVG/profile-icon-black.svg" width="24px" height="24px" alt="Profile" />
          </div>
          <div class="header-icon-icon-height show-safari">
            <img src="assets/SVG/profile-icon.png" width="24px" height="24px" alt="Profile" />
          </div>
        </div>
        <div class="account-header">
          <span class="account-header-copy text-capitalize" *ngIf="showUserName">
            <!-- {{ "ACCOUNT" | translate | titlecase }} -->
            {{ showUserName | translate | titlecase }}
          </span>
          <div class="header-arrow-icon-box">
            <img src="assets/SVG/icon-profile-arrow-down-acmic.svg" alt="Account" />
          </div>
        </div>
      </ng-container>
      <ng-template #otherState>
        <div class="header-profile-icon-for-mobile">
          <div class="header-icon-icon-height">
            <img src="assets/SVG/icon-account.svg" width="24px" height="24px" alt="Account" />
          </div>
        </div>
        <div class="account-header">
          <span class="account-header-copy text-capitalize" *ngIf="showUserName">
            <!-- {{ "ACCOUNT" | translate | titlecase }} -->
            {{ showUserName | translate | titlecase }}
          </span>
          <span class="down-arrow-for-ma"></span>
          <!-- <img src="assets/SVG/account-down-arrow-new.svg" alt="Account" /> -->
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="additionalClasses.includes('footer-flat')">
      <span class="first-icon">
        <mapfre-icon [iconClasses]="iconClassesArray[0]" [iconFamily]="iconFamily"></mapfre-icon>
      </span>
      <span class="button-content" [ngClass]="{ 'sr-only sr-only-focusable': screenReader }">
        {{ buttonCopy | translate }}
      </span>
      <span class="second-icon">
        <mapfre-icon [iconClasses]="iconClassesArray[1]" [iconFamily]="iconFamily"></mapfre-icon>
      </span>
    </ng-container>

    <ng-container *ngIf="showIconsCustom">
      <span>
        <img [src]="backIcon" class="custom-button-icon {{ iconClasses }}" alt="icon" />
      </span>
    </ng-container>

    <ng-container *ngIf="
        !additionalClasses.includes('footer-flat') &&
        !additionalClasses.includes('header-flat') &&
        !showIconsCustom
      ">
      <ng-container *ngIf="showIcons">
        <span class="first-icon">
          <mapfre-icon [iconClasses]="iconClassesArray[0]" [iconFamily]="iconFamily"></mapfre-icon>
        </span>
      </ng-container>

      <span class="button-content" [ngClass]="{ 'sr-only sr-only-focusable': screenReader }">
        {{ buttonCopy | translate }}
      </span>
      <ng-container *ngIf="iconClassesArray.length >= 2">
        <span class="second-icon">
          <mapfre-icon [iconClasses]="iconClassesArray[1]" [iconFamily]="iconFamily"></mapfre-icon>
        </span>
      </ng-container>
    </ng-container>
  </button>

  <button id="{{btnId}}" class="btn mapfre {{ additionalClasses }}" type="button" *ngSwitchCase="'upload-button'" mdbRipple>
    {{ translateValue }}
  </button>

  <button  class="btn mapfre {{ additionalClasses }}" type="button" *ngSwitchDefault mdbRipple>
    <ng-container *ngIf="showIcons">
      <span>
        <mapfre-icon [iconClasses]="iconClasses" [iconFamily]="iconFamily"></mapfre-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="showIconsCustom">
      <span>
        <img [src]="backIcon" class="custom-button-icon {{ iconClasses }}" alt="back space arrow icon" />
      </span>
    </ng-container>
    <ng-content></ng-content>
  </button>
</ng-container>